import {useMutation, useQueryClient} from '@tanstack/react-query'
import {withdrawGoal} from '../services/goal.http'
import {QUERY_KEYS} from './keys'

export const useWithdrawMicroMorgisGoalV3 = (onSuccess: () => void) => {
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: withdrawGoal,
        onSuccess: data => {
            onSuccess()
            queryClient.setQueriesData({queryKey: [QUERY_KEYS.selectedGoal, data.id.toString()]}, data)
        }
    })
}
